// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"70e28934","513":"830264da","703":"89cb4ae0"}[chunkId] + ".chunk.js";
};